var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 36,
    height: 36,
    rx: 18,
    fill: "#0169FF",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3072 18.4733C22.2452 18.4108 22.1715 18.3612 22.0902 18.3273C22.009 18.2935 21.9219 18.2761 21.8339 18.2761C21.7459 18.2761 21.6587 18.2935 21.5775 18.3273C21.4962 18.3612 21.4225 18.4108 21.3605 18.4733L19.1672 20.6666V13.9999C19.1672 13.8231 19.097 13.6535 18.9719 13.5285C18.8469 13.4035 18.6773 13.3333 18.5005 13.3333C18.3237 13.3333 18.1541 13.4035 18.0291 13.5285C17.9041 13.6535 17.8339 13.8231 17.8339 13.9999V20.6666L15.6405 18.4733C15.5786 18.4108 15.5048 18.3612 15.4236 18.3273C15.3423 18.2935 15.2552 18.2761 15.1672 18.2761C15.0792 18.2761 14.992 18.2935 14.9108 18.3273C14.8296 18.3612 14.7558 18.4108 14.6939 18.4733C14.5697 18.5982 14.5 18.7671 14.5 18.9433C14.5 19.1194 14.5697 19.2883 14.6939 19.4133L17.5605 22.2733C17.8094 22.5236 18.1475 22.6651 18.5005 22.6666C18.8513 22.6633 19.1866 22.522 19.4339 22.2733L22.3005 19.4133C22.4256 19.2892 22.4965 19.1208 22.4977 18.9446C22.499 18.7685 22.4305 18.599 22.3072 18.4733Z",
    fill: "#0169FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down_arrow.1a98482db89dd961a973a958ffbaedb9.svg";
export { ForwardRef as ReactComponent };